export const CHART_SETTINGS = {
  dashboardHEIGHT: 200,
  portfolioHEIGHT: 260,
  LINE_COLOR: "#81CF1D",
  SECOND_LINE_COLOR: "#006BFF",
};
